import { Component } from "@angular/core";

@Component({
  selector: "app-facebook-connect-info-dialog",
  templateUrl: "./facebook-connect-info-dialog.component.html",
  styleUrls: ["./facebook-connect-info-dialog.component.scss"],
})
export class FacebookConnectInfoDialogComponent {}
